import { ERecommendationActionTypes } from '../../actions/recommendations/types';
import { ELoadingStatus } from '../../types/loadingStatus';
import { EPaginationStatus, IRecommendation, TRecommendation } from '../../types/recommendation';
import { TReduxActions } from '../../types/redux';

const INITIAL_PAGE = 0;

export const initialState = {
  data: [] as TRecommendation[],
  status: ELoadingStatus.Loading,
  page: INITIAL_PAGE,
  hasMore: false,
  paginationStatus: EPaginationStatus.Idle,
};

export function recommendationsReducer(state = initialState, action: TReduxActions): IRecommendation {
  switch (action.type) {
    case ERecommendationActionTypes.Pending:
      return {
        ...state,
        status: ELoadingStatus.Loading,
        paginationStatus: EPaginationStatus.Idle,
      };

    case ERecommendationActionTypes.Fulfilled:
      return {
        ...state,
        status: ELoadingStatus.Success,
        data: action.payload.data,
        page: INITIAL_PAGE,
        hasMore: action.payload.hasMore,
        paginationStatus: EPaginationStatus.Idle,
      };

    case ERecommendationActionTypes.Rejected:
      return {
        ...state,
        status: ELoadingStatus.Failure,
        hasMore: false,
        page: INITIAL_PAGE,
        paginationStatus: EPaginationStatus.Idle,
      };

    case ERecommendationActionTypes.MorePending:
      return {
        ...state,
        paginationStatus: EPaginationStatus.Loading,
      };

    case ERecommendationActionTypes.MoreFulfilled:
      return {
        ...state,
        data: [...state.data, ...action.payload.data],
        page: action.payload.page,
        hasMore: action.payload.hasMore,
        paginationStatus: EPaginationStatus.Idle,
      };

    case ERecommendationActionTypes.MoreRejected:
      return {
        ...state,
        paginationStatus: EPaginationStatus.Error,
      };

    case ERecommendationActionTypes.ToggleFavorite:
      return {
        ...state,
        data: state.data.map(recommendation =>
          recommendation.offerId === action.payload.offerId
            ? { ...recommendation, isFavorite: action.payload.isFavorite }
            : recommendation,
        ),
      };

    default:
      return state;
  }
}
